import React, { Component } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import AssignedEducationOptions from "./AssignedEducationOptions";
import AssignedEducationPrompts from "./AssignedEducationPrompts";
import ComprehensionQuestion from "./ComprehensionQuestion";
import VideoPlayer from "../common/videoPlayer";
import "./styles.css";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { withRouter } from 'react-router-dom';

class Service1244 extends Component {
  handleVideoFinished = id => {
    this.setState({
      medicalEducationButtons: this.state.medicalEducationButtons.map(button => {
        if (button.id === id) {
          return Object.assign({}, button, {
            checked: true
          });
        } else {
          return button;
        }
      }),
      prescribedEducationButtons: this.state.prescribedEducationButtons.map(button => {
        if (button.id === id) {
          return Object.assign({}, button, {
            checked: true
          });
        } else {
          return button;
        }
      })
    });
  };

  /**************
   * Properties *
   **************/

  /**
   * The service's different screens
   */
  bannerVisible = {
    visible: true
  };
  rolesNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: "/main_menu"
  };
  introNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: "/main_menu"
  };
  prescribedNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: "/assigned_education/roles"
  };
  rolesButtons = [
    {
      id: "patient",
      to: "prescribed_education",
      highlight: require("./images/Role1_HL.png"),
      unhighlight: require("./images/Role1_UH.png"),
      alt: "Patient"
    },
    {
      id: "familyMember",
      to: "prescribed_education",
      highlight: require("./images/Role2_HL.png"),
      unhighlight: require("./images/Role2_UH.png"),
      alt: "Family Member(s)"
    },
    {
      id: "both",
      to: "prescribed_education",
      highlight: require("./images/Role3_HL.png"),
      unhighlight: require("./images/Role3_UH.png"),
      alt: "Both"
    }
  ];
  rolesHeader = {
    id: "header",
    src: require("./images/1244_elements_roles.png")
  };
  rolesButtonList = {
    top: 170,
    left: 585
  };
  introHeader = {
    id: "header",
    src: require("./images/1244_elements_intro.png")
  };
  introButtonList = {
    top: 170,
    left: 585
  };
  introButtons = [
    {
      id: "prescribedEducation",
      to: "prescribed_education",
      highlight: require("./images/Edu_intro_HL.png"),
      unhighlight: require("./images/Edu_intro_UH.png"),
      alt: "Prescribed Education"
    },
    {
      id: "prescribedMedicalEducation",
      to: "prescribed_medical_education",
      highlight: require("./images/Meds_intro_HL.png"),
      unhighlight: require("./images/Meds_intro_UH.png"),
      alt: "Prescribed Medication Education"
    }
  ];
  medicalEducationHeader = {
    id: "header",
    src: require("./images/1244_elements.png")
  };
  medicalEducationText = {
    id: "text",
    src: require("./images/hdr_meds.png"),
    top: 150,
    left: 0
  };
  medicalEducationButtonList = {
    top: 250,
    left: 135
  };
  prescribedEducationHeader = {
    id: "header",
    src: require("./images/1244_elements.png")
  };
  prescribedEducationText = {
    id: "text",
    src: require("./images/hdr_edu.png"),
    top: 150,
    left: 0
  };
  prescribedEducationButtonList = {
    top: 250,
    left: 135
  };
  videoNavigationBar = {
    mainMenu: false,
    back: false,
    backRoute: null,
    doGoBack: true
  };
  defaultVideo = {
    id: "default",
    src: require("./videos/Coronary_Angiography_186128HD.mp4"),
    onVideoEnded: this.handleVideoFinished
  };
  angiography = Object.assign({}, this.defaultVideo, { id: "angiography" });
  managingDiabetesBasicSkills = Object.assign({}, this.defaultVideo, {
    id: "managingDiabetesBasicSkills",
    src: require("./videos/Managing_Stress_Heart_Disease_294248HD.mp4")
  });
  heartFailureMakingLifestyleChanges = Object.assign({}, this.defaultVideo, {
    id: "heartFailureMakingLifestyleChanges"
  });
  healthyWaysPrepareFood = Object.assign({}, this.defaultVideo, {
    id: "healthyWaysPrepareFood",
    src: require("./videos/Managing_Stress_Heart_Disease_294248HD.mp4")
  });
  tipsAchievingHealthyLifestyleChanges = Object.assign({}, this.defaultVideo, {
    id: "tipsAchievingHealthyLifestyleChanges"
  });
  abilify = Object.assign({}, this.defaultVideo, {
    id: "abilify",
    src: require("./videos/254953HD_v2_Abilify_AssignedEd.mp4")
  });
  botox = Object.assign({}, this.defaultVideo, {
    id: "botox",
    src: require("./videos/254820HD_v2_Botox_AssignedEd.mp4")
  });
  claritin = Object.assign({}, this.abilify, { id: "claritin" });
  warfarin = Object.assign({}, this.botox, { id: "warfarin" });
  xanax = Object.assign({}, this.abilify, { id: "xanax" });

  med1HL = require("./images/" + this.props.currentPatient + "_1244_Med_Title1_HL.png");
  med1UH = require("./images/" + this.props.currentPatient + "_1244_Med_Title1_UH.png");
  med2HL = require("./images/" + this.props.currentPatient + "_1244_Med_Title2_HL.png");
  med2UH = require("./images/" + this.props.currentPatient + "_1244_Med_Title2_UH.png");
  med3HL = require("./images/" + this.props.currentPatient + "_1244_Med_Title3_HL.png");
  med3UH = require("./images/" + this.props.currentPatient + "_1244_Med_Title3_UH.png");
  edu1HL = require("./images/" + this.props.currentPatient + "_1244_Edu_Title1_HL.png");
  edu1UH = require("./images/" + this.props.currentPatient + "_1244_Edu_Title1_UH.png");
  edu2HL = require("./images/" + this.props.currentPatient + "_1244_Edu_Title2_HL.png");
  edu2UH = require("./images/" + this.props.currentPatient + "_1244_Edu_Title2_UH.png");
  edu3HL = require("./images/" + this.props.currentPatient + "_1244_Edu_Title3_HL.png");
  edu3UH = require("./images/" + this.props.currentPatient + "_1244_Edu_Title3_UH.png");

  state = {
    currentPatient: this.props.currentPatient,
    medicalEducationButtons: [
      {
        id: "enoxaparin",
        to: "/assigned_education/enoxaparin",
        highlight: this.edu1HL,
        unhighlight: this.edu1UH,
        alt: "Enoxaparin",
        checked: false
      }
    ],
    prescribedEducationButtons: [
      {
        id: "jointReplacementPreventingBloodClots",
        to: "/assigned_education/multilingual/angiography/comprehension",
        highlight: this.edu1HL,
        unhighlight: this.edu1UH,
        alt: "Joint Replacement: Preventing Blood Clots",
        checked: false
      },
      {
        id: "jointReplacementYourHospitalStay",
        to: "/assigned_education/prescribed_education/multilingual/managing_diabetes_basic_skills",
        highlight: this.edu2HL,
        unhighlight: this.edu2UH,
        alt: "Joint Replacement: Your Hospital Stay",
        checked: false
      },
      {
        id: "hipSurgeryHipPrecautions",
        to: "/assigned_education/heart_failure_making_lifestyle_Changes",
        highlight: this.edu3HL,
        unhighlight: this.edu3UH,
        alt: "Hip Surgery: Hip Precautions",
        checked: false
      },
      {
        id: "enoxaparin",
        to: "/assigned_education/enoxaparin",
        highlight: this.med1HL,
        unhighlight: this.med1UH,
        alt: "Enoxaparin",
        checked: false
      },
      {
        id: "docusate",
        to: "/assigned_education/docusate",
        highlight: this.med2HL,
        unhighlight: this.med2UH,
        alt: "Docusate",
        checked: false
      },
      {
        id: "nexium",
        to: "/assigned_education/nexium",
        highlight: this.med3HL,
        unhighlight: this.med3UH,
        alt: "Nexium",
        checked: false
      }
    ]
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPatient !== this.props.currentPatient) {
      this.setState({ 
        currentPatient: this.props.currentPatient
       });
        this.med1HL = require("./images/" + this.props.currentPatient + "_1244_Med_Title1_HL.png");
        this.med1UH = require("./images/" + this.props.currentPatient + "_1244_Med_Title1_UH.png");
        this.med2HL = require("./images/" + this.props.currentPatient + "_1244_Med_Title2_HL.png");
        this.med2UH = require("./images/" + this.props.currentPatient + "_1244_Med_Title2_UH.png");
        this.med3HL = require("./images/" + this.props.currentPatient + "_1244_Med_Title3_HL.png");
        this.med3UH = require("./images/" + this.props.currentPatient + "_1244_Med_Title3_UH.png");
        this.edu1HL = require("./images/" + this.props.currentPatient + "_1244_Edu_Title1_HL.png");
        this.edu1UH = require("./images/" + this.props.currentPatient + "_1244_Edu_Title1_UH.png");
        this.edu2HL = require("./images/" + this.props.currentPatient + "_1244_Edu_Title2_HL.png");
        this.edu2UH = require("./images/" + this.props.currentPatient + "_1244_Edu_Title2_UH.png");
        this.edu3HL = require("./images/" + this.props.currentPatient + "_1244_Edu_Title3_HL.png");
        this.edu3UH = require("./images/" + this.props.currentPatient + "_1244_Edu_Title3_UH.png");
      this.forceUpdate();
    } else {
      return null
    }
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1244">
        <Switch>
          <Route path="/assigned_education/comprehension/:question" component={ComprehensionQuestion} />
          <Route
            path="/assigned_education/comprehension"
            render={() => <Redirect to="/assigned_education/comprehension/1" />}
          />
          <Route
            path="/assigned_education/multilingual/:videoName/:hasComprehension?"
            render={({ match }) => {
              let link = `/assigned_education/prescribed_education/multilingual/${match.params.videoName}`;
              if (match.params.hasComprehension) {
                link = `${link}/${match.params.hasComprehension}`;
              }
              return <Redirect to={link} />;
            }}
          />
          <Route
            path="/assigned_education/prompts/:back"
            render={routeProps => <AssignedEducationPrompts {...routeProps} />}
          />
          <Route
            path="/assigned_education/roles"
            render={routeProps => (
              <AssignedEducationOptions
                {...routeProps}
                header={this.rolesHeader}
                banner={this.bannerVisible}
                navigationBar={this.rolesNavigationBar}
                imageButtonsList={this.rolesButtonList}
                imageButtons={this.rolesButtons}
              />
            )}
          />
          <Route
            path="/assigned_education/patient"
            render={routeProps => (
              <AssignedEducationOptions
                {...routeProps}
                header={this.rolesHeader}
                banner={this.bannerVisible}
                navigationBar={this.rolesNavigationBar}
                imageButtonsList={this.rolesButtonList}
                imageButtons={this.rolesButtons}
              />
            )}
          />
          <Route
            path="/assigned_education/family_member"
            render={() => <Redirect to="/assigned_education/patient" />}
          />
          <Route path="/assigned_education/both" render={() => <Redirect to="/assigned_education/patient" />} />
          <Route
            path="/assigned_education/prescribed_education/:multilingual?/:videoName?/:hasComprehension?"
            render={routeProps => (
              <AssignedEducationOptions
                {...routeProps}
                header={this.prescribedEducationHeader}
                text={this.prescribedEducationText}
                banner={this.bannerVisible}
                navigationBar={this.prescribedNavigationBar}
                imageButtonsList={this.prescribedEducationButtonList}
                imageButtons={this.state.prescribedEducationButtons}
              />
            )}
          />
          <Route
            path="/assigned_education/prescribed_medical_education"
            render={routeProps => (
              <AssignedEducationOptions
                {...routeProps}
                header={this.medicalEducationHeader}
                text={this.medicalEducationText}
                banner={this.bannerVisible}
                navigationBar={this.prescribedNavigationBar}
                imageButtonsList={this.medicalEducationButtonList}
                imageButtons={this.state.medicalEducationButtons}
              />
            )}
          />
          <Route
            path="/assigned_education/angiography/:backRoute?"
            render={routeProps => {
              let navigationBar = this.videoNavigationBar;
              if (routeProps.match.params.backRoute) {
                navigationBar.doGoBack = false;
                navigationBar.backRoute = `/assigned_education/${routeProps.match.params.backRoute}`;
              }
              return <VideoPlayer {...routeProps} {...this.angiography} navigationBar={navigationBar} />;
            }}
          />
          <Route
            path="/assigned_education/managing_diabetes_basic_skills/:backRoute?"
            render={routeProps => {
              let navigationBar = this.videoNavigationBar;
              if (routeProps.match.params.backRoute) {
                navigationBar.doGoBack = false;
                navigationBar.backRoute = `/assigned_education/${routeProps.match.params.backRoute}`;
              }
              return (
                <VideoPlayer {...routeProps} {...this.managingDiabetesBasicSkills} navigationBar={navigationBar} />
              );
            }}
          />
          <Route
            path="/assigned_education/heart_failure_making_lifestyle_changes"
            render={routeProps => (
              <VideoPlayer
                {...routeProps}
                {...this.heartFailureMakingLifestyleChanges}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/assigned_education/healthy_ways_prepare_food"
            render={routeProps => (
              <VideoPlayer {...routeProps} {...this.healthyWaysPrepareFood} navigationBar={this.videoNavigationBar} />
            )}
          />
          <Route
            path="/assigned_education/tips_achieving_healthy_lifestyle_changes"
            render={routeProps => (
              <VideoPlayer
                {...routeProps}
                {...this.tipsAchievingHealthyLifestyleChanges}
                navigationBar={this.videoNavigationBar}
              />
            )}
          />
          <Route
            path="/assigned_education/enoxaparin"
            render={routeProps => (
              <VideoPlayer {...routeProps} {...this.abilify} navigationBar={this.videoNavigationBar} />
            )}
          />
          <Route
            path="/assigned_education/docusate"
            render={routeProps => (
              <VideoPlayer {...routeProps} {...this.botox} navigationBar={this.videoNavigationBar} />
            )}
          />
          <Route
            path="/assigned_education/nexium"
            render={routeProps => (
              <VideoPlayer {...routeProps} {...this.claritin} navigationBar={this.videoNavigationBar} />
            )}
          />
          <Route
            path="/assigned_education/warfarin"
            render={routeProps => (
              <VideoPlayer {...routeProps} {...this.warfarin} navigationBar={this.videoNavigationBar} />
            )}
          />
          <Route
            path="/assigned_education/xanax"
            render={routeProps => (
              <VideoPlayer {...routeProps} {...this.xanax} navigationBar={this.videoNavigationBar} />
            )}
          />
          <Route path="/assigned_education" render={() => <Redirect to="/assigned_education/roles" />} />
        </Switch>
      </div>
    );
  }
}

const ConnectedService1244 = connect(
  state => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(Service1244);

export default withRouter(ConnectedService1244);
